export default __webpack_public_path__ + "static/royal-free-london-2517e7c4266ee2b19b553a5036d25e6b.png";